import Routes from "./components/Routes";
import { UserProvider } from "./context/UserContext";
import { ContentProvider } from "./context/ContentContext";

function App() {
  return (
    <div>
      <UserProvider>
        <ContentProvider>
          <Routes />
        </ContentProvider>
      </UserProvider>
    </div>
  );
}

export default App;
